// Time helpers (relocated from mockData.js — Phase 10F). No event data here.

export const getTimeRemaining = (dateISO) => {
  const now = new Date();
  const eventDate = new Date(dateISO);
  const diff = eventDate - now;

  if (isNaN(diff) || diff <= 0) return { expired: true };

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds, expired: false };
};
